(function () {
    'use strict';
    angular.module('GorillaBoy.directives')
    .directive('documentViewUpload', ['$rootScope', '$q', '$translate', 'DocumentService', 'BrowserService', 'MessageProvider', 'MessageManager', 'ModalFactory', 'GUIDGenerator', 'SignalProvider', 'AppConstants', '$log',
        function ($rootScope, $q, $translate, DocumentService, BrowserService, MessageProvider, MessageManager, ModalFactory, GUIDGenerator, SignalProvider, AppConstants, $log) {
            return {
                restrict: 'E',
                scope: true,
                link: function (scope, element, attrs) {
                    
                    //////////////////////////////////////
                    // SETUP
                    //////////////////////////////////////
                    var jqueryFileUploadWidget = element.find('.jquery_file_upload_widget');
                    var deregRootScopeDragStartListener = $rootScope.$on(SignalProvider.Document.StartDragging, rootScopeDragStartListener);
                    scope.inputId = 'file_input_from_pane';
                    scope.documentInputPaneId = GUIDGenerator.generate();

                    attrs.$observe('drag', function(drag) {
                        $log.info("Inside $observe for 'drag' attrs ");
                        scope.dragUploadPane = drag;
                    });
                    attrs.$observe('inMenu', function(inMenu) {
                        $log.info("Inside $observe for 'inMenu' attrs ");
                        if(!!inMenu) {
                            scope.inputId = 'file_input_from_menu';
                        }
                    });               
                    scope.$on('$destroy', function() {
                        deregRootScopeDragStartListener();                        
                        element.find('.jquery_file_upload_widget').fileupload('destroy');
                    });
                    //////////////////////////////////////
                    // HELPER FUNCTIONS
                    //////////////////////////////////////
                    var checkoutNameValidation = function(fileToUpload) {
                        //If the file name is not the same, then we don't allow new draft version upload
                        var fileObj = fileToUpload.files[0];
                        var deferred = $q.defer();
                        if (fileObj.name !== scope.metadata.VersionMetadata.Name && scope.metadata.CheckoutInfo &&
                                scope.metadata.CheckoutInfo.CheckoutUserId === scope.userInfo.Id) {
                            //Show the following prompt only to the checkout upload scenario
                            var title = $translate.instant('CHECKIN_CHECKOUT.FILE_UPLOAD_IN_DOC_VIEWER_WITH_NAME_CHANGED.TITLE'),
                                okayButtonText = $translate.instant('CHECKIN_CHECKOUT.FILE_UPLOAD_IN_DOC_VIEWER_WITH_NAME_CHANGED.OKAY_BUTTON'),
                                cancelButtonText = $translate.instant('CHECKIN_CHECKOUT.FILE_UPLOAD_IN_DOC_VIEWER_WITH_NAME_CHANGED.CANCEL_BUTTON'),
                                message = $translate.instant('CHECKIN_CHECKOUT.FILE_UPLOAD_IN_DOC_VIEWER_WITH_NAME_CHANGED.MESSAGE', {
                                OldFileName : scope.metadata.VersionMetadata.Name,
                                NewFileName : fileObj.name
                            });
                            ModalFactory.showConfirmationModal(title, message, okayButtonText, cancelButtonText).then(function() {
                                fileObj.overrideName = scope.metadata.VersionMetadata.Name;
                                deferred.resolve();
                            }, function() {
                                deferred.reject();
                            });
                        } else {
                            deferred.resolve();
                        }
                        return deferred.promise;
                    };
                    var uploadFile = function(fileToUpload) {
                        var fileObj = fileToUpload.files[0];
                        DocumentService.InitiateDocumentVersionUpload(fileObj.docId, fileObj.overrideName || fileObj.name, fileObj.contentType, fileObj.size, fileObj.folderId, fileObj.CheckoutId, null, fileObj.passcode)
                        .success(function(data) {
                            var docMetadata = data.Metadata,
                                docVersionMetadata = data.Metadata.LatestVersionMetadata,
                                docId = data.Metadata.Id;
                            // new API deprecated VersionMetadata field in docMetadata, and uses LatestVersionMetadata field instead.
                            // However, client side still uses VersionMetadata to populate data on page.
                            // Assign value to VersionMetadatav filed to avoid page broken.
                            delete data.Metadata.LatestVersionMetadata;

                            if (scope.userActionsMap) {
                                delete scope.userActionsMap[docId];
                            }

                            docVersionMetadata.VersionId = docVersionMetadata.Id;
                            docMetadata.VersionMetadata = docVersionMetadata;
                            fileObj.docMetadata = docMetadata;
                            var s3url = data.DocumentVersionUrl;
                            var signedHeaders = data.UploadMetadata.SignedHeaders;

                            if (s3url && signedHeaders) {
                                fileToUpload.url = s3url;
                                fileObj.documentId = docId;
                                fileObj.versionId = docVersionMetadata.Id;

                                // Doc View: Add it to the version set.
                                if (scope.documentState && scope.documentState.documentVersions) {
                                    if (docVersionMetadata.VersionStatus === AppConstants.DOCUMENT_VERSION_STATUS.DRAFT) {
                                        var versionMetadataIdx = _.findIndex(scope.documentState.documentVersions, function(versionMetadata) {
                                            return versionMetadata.Id === docVersionMetadata.Id;
                                        });
                                        scope.documentState.documentVersions[versionMetadataIdx] = docVersionMetadata;
                                    } else {
                                        scope.documentState.documentVersions.unshift(docVersionMetadata);
                                    }
                                }

                                fileToUpload.File = fileObj;
                                fileToUpload.paramName = "File";
                                fileToUpload.headers = signedHeaders;
                                fileToUpload.submit();
                            } else {
                                $log.log("Did not receive the S3 url or signed headers.");
                            }
                        })
                        .error(function(data, status, headers, config) {
                            var errorShown = false;
                            $log.error("Failed to upload file with name " + fileToUpload.files[0].name);
                            // TODO(fxc): Follow up with design and use the pattern from a failed service call here.
                            if (data && data.Message) {
                                if (data.Message.indexOf('ProhibitedStateException') === 0) {
                                    MessageManager.addErrorUploadMessage($translate.instant('CHECKIN_CHECKOUT.ERROR_WHILE_SINGLE_FILE_UPLOAD_DUE_RENAME'));
                                    errorShown = true;
                                } else if (data.Message.indexOf('ResourceAlreadyCheckedOutException') >= 0) {
                                    MessageManager.addErrorUploadMessage($translate.instant('CHECKIN_CHECKOUT.ERROR_WHILE_SINGLE_FILE_UPLOAD'));
                                    errorShown = true;
                                } else if (data.Message.indexOf('EntityAlreadyExistsException') >= 0) {
                                    MessageManager.addErrorUploadMessage(MessageProvider.uploadFailAlreadyExists(fileToUpload.files[0].name), null, [fileToUpload.files[0]]);
                                    errorShown = true;
                                } else if (data.Message.indexOf('EntityNotExistsException') >= 0) {
                                    MessageManager.addErrorUploadMessage(MessageProvider.uploadFailFolderNotExists(fileToUpload.files[0].name), null, [fileToUpload.files[0]]);
                                    errorShown = true;
                                } else if (data.Message.indexOf('StorageLimitExceededException') >= 0 || data.Message.indexOf('StorageLimitWillExceedException') >= 0) {
                                    MessageManager.addErrorUploadMessage(MessageProvider.uploadFailStorageLimitWillExceed());
                                    errorShown = true;
                                } else if (data.Message.indexOf('FileSizeLimitExceededException') >= 0 ) {
                                    MessageManager.addErrorUploadMessage(MessageProvider.uploadFailFileSizeWillExceed());
                                    errorShown = true;
                                }
                            } else if (data && data.message) {
                                if (data.message.indexOf('ValidationException') >= 0) {
                                    MessageManager.addErrorUploadMessage(MessageProvider.uploadFailInvalidFileName());
                                    errorShown = true;
                                }
                            }
                            if (!errorShown) {
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailDefault(fileToUpload.files[0].name), null, [fileToUpload.files[0]]);
                            }
                        });
                    };

                    function rootScopeDragStartListener() {
                        if (scope.dragUploadPane) {
                            scope.dragToUpload = true;    
                        }                        
                    }
                    
                    //////////////////////////////////////
                    // MAIN LOGICS
                    //////////////////////////////////////
                    if (scope.documentState) {
                        scope.documentState.documentInputPaneId = scope.documentInputPaneId;
                    }
                    $(jqueryFileUploadWidget).fileupload({
                        // Upload via PUT
                        type: AppConstants.HttpMethods.PUT,
                        // Disable multipart form uploads. If internet explorer, set to true to submit form data
                        multipart: false,
                        // The jQuery object for the file input field to listen on.
                        fileInput: $(jqueryFileUploadWidget),
                        // Enable server-side encryption for all S3 uploads
                        add: function(event, data) {
                            if ((!!scope.dragUploadPane && !!scope.dragToUpload ||
                                    !scope.dragUploadPane && !scope.dragToUpload) &&
                                (scope.layout.showUploadPane === undefined || scope.layout.showUploadPane)) {
                                // Assign more readable names for file data and file object
                                var fileToUpload = data,
                                    fileObj = data.files[0];
                                // Handle invalid cases
                                if(fileToUpload.originalFiles.length > 1) {
                                    MessageManager.addErrorMessage($translate.instant('DOCUMENT_VIEW.MULTIPLE_FILE_UPLOAD_NOT_SUPPORTED'));
                                    event.preventDefault();
                                    return false;
                                } 
                                else if(fileToUpload.originalFiles.length === 1 && (fileObj.relativePath && fileObj.relativePath !== '')) {
                                    MessageManager.addErrorMessage($translate.instant('DOCUMENT_VIEW.CANNOT_UPLOAD_FOLDER_IN_DOCUMENT_VIEW'));
                                    event.preventDefault();
                                    return false;
                                }
                                if(fileObj.name.length > AppConstants.Upload.MAX_NAME_LENGTH) {
                                    MessageManager.addErrorUploadMessage(MessageProvider.uploadFailNameTooLong, null, [data.files[0]]);
                                    return;
                                }

                                var docId = scope.documentState.documentId,
                                    folderId = scope.documentState.parentFolderId,
                                    CheckoutGuid = scope.metadata.CheckoutInfo? scope.metadata.CheckoutInfo.CheckoutGuid : undefined,
                                    passcode = scope.passcode;
                                fileObj.folderId = folderId;
                                fileObj.docId = docId;
                                fileObj.CheckoutId = CheckoutGuid;
                                fileObj.contentType = scope.getContentType(fileObj);
                                fileObj.passcode = passcode;
                                checkoutNameValidation(fileToUpload)
                                .then(function() {
                                    uploadFile(fileToUpload);
                                })
                                .catch(function() {});
                            } else {
                                //TODO(fxc): Followup with design. Do we need an error message for lack of permissions?
                            }
                        },
                        drop: function(e, data) {
                            // Disable drop listener if dragToUpload is set to false
                            if (!scope.dragToUpload) {
                                return false;
                            }
                            if(BrowserService.isSafari()) {
                                var files = data.files;
                                var file;
                                for(var i=0; i<files.length ; i++) {
                                    file = files[i];
                                    if(!file.type) {
                                        MessageManager.addInfoMessage($translate.instant('MESSAGES.FOLDER_UPLOAD_FAIL_BROWSER_NOT_SUPPORT'));
                                        return false;
                                    }
                                }
                            }
                            return true;
                        },
                        submit: function(e, data) {
                            return true;
                        },
                        send: function(e, data) {
                            data.contentType = data.files[0].contentType;
                            return true;
                        },
                        progress: function(e, data) {
                            var progress = parseInt(data.loaded / data.total * 100, 10);
                            // broadcast the progress to file browser
                            $rootScope.$broadcast(SignalProvider.Document.uploadProgress, progress, data.File.folderId, data);
                        },
                        fail: function(e, data) {
                            // Abort the file uploads.
                            $log.error("AbortDocumentVersionUpload called for " + data.File.documentId + " reason: " + JSON.stringify(data.messages) + JSON.stringify(data._response));
                            // Notify user of upload failure.
                            var res = data._response.jqXHR;
                            if (res.status === 403 &&  res.responseText && res.responseText.indexOf('Access Denied') > 0) {
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailKmsError(data.File.name, window.location.hostname), null, [data.File]);
                                $rootScope.metricServiceInstance.newCounterMetric('DocumentViewer.Error.' + res.status + '.KMS.VersionUpload');
                            } else {
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailDefault(data.File.name), null, [data.File]);
                                $rootScope.metricServiceInstance.newCounterMetric('DocumentViewer.Error.' + res.status + '.VersionUpload');
                            }
                            DocumentService.deleteDocumentVersion(data.File.documentId, data.File.versionId);
                        },
                        done: function(event, data) {
                            // Finalize the upload and init document controls.
                            DocumentService.updateDocumentVersion(data.File.documentId, data.File.versionId)
                            .success(function() {
                                $rootScope.$broadcast(SignalProvider.Document.Uploaded, data.File.documentId, data.File.versionId);
                                $log.log("File upload done for file: " + data.File.name);
                            })
                            .error(function(d, status, headers, config) {
                                $log.error("File upload failed for file: " + data.File.documentId);
                                // Notify user of upload failure.
                                MessageManager.addErrorUploadMessage(MessageProvider.uploadFailDefault(data.File.name), null, [data.File]);
                                // Abort the file upload.
                                DocumentService.deleteDocumentVersion(data.File.documentId, data.File.versionId);
                            });
                        }
                    });
                },
                template: '<div class="file_input_div">' +
                '<input tabindex="-1" id="{{inputId}}" type="file" name="files[]" multiple="multiple" class="hidden fileInput jquery_file_upload_widget" />' + '</div>'
            };
        }
    ]);
}());